<template>
  <div class="d-flex" id="wrapper">
    <div class="bg-light border-right" id="sidebar-wrapper">
      <div class="sidebar-heading">Painel do Professor</div>
      <div class="list-group list-group-flush">
        <a
          class="list-group-item list-group-item-action bg-light"
          :class="{ 'active': page === 'my-courses' }"
          href="#my-courses" @click="showPage('my-courses')"
        >Meus Cursos</a>
        <a
          class="list-group-item list-group-item-action bg-light"
          :class="{ 'active': page === 'sells' }"
          href="#sells" @click="showPage('sells')"
        >Vendas</a>
        <a
          class="list-group-item list-group-item-action bg-light"
          :class="{ 'active': page === 'reports' }"
          href="#reports" @click="showPage('reports')"
        >Relatórios</a>
        <!-- <a
          class="list-group-item list-group-item-action bg-light"
          :class="{ 'active': page === 'cupons' }"
          href="#cupons" @click="showPage('cupons')"
        >Cupons</a> -->
        <a
          class="list-group-item list-group-item-action bg-light"
          :class="{ 'active': page === 'doubts' }"
          href="#doubts" @click="showPage('doubts')"
        >Dúvidas</a>
        <a
          class="list-group-item list-group-item-action bg-light"
          :class="{ 'active': page === 'finance' }"
          href="#finance" @click="showPage('finance')"
        >Financeiro</a>

        <router-link class="list-group-item list-group-item-action bg-akdemica text-white" to="/professor/adicionar/curso">
          Criar Curso
        </router-link>

        <a href="#" @click.prevent="showModalUser()" class="list-group-item list-group-item-action bg-light">Meu Perfil</a>
      </div>
    </div>
    <div id="page-content-wrapper">
      <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom">
        <button class="btn btn-dark" @click.prevent="toggleMenu"><i class="fa fa-bars"></i></button>
      </nav>

      <div class="pt-3 px-4">
        <my-courses v-if="page === 'my-courses'" />
        <my-co-courses v-if="page === 'my-courses'" />
        <doubts v-else-if="page === 'doubts'" />
        <cupons v-else-if="page === 'cupons'" />
        <reports v-else-if="page === 'reports'" />
        <sells v-else-if="page === 'sells'" />
        <finance v-else-if="page === 'finance'" />
      </div>
    </div>
  </div>
</template>

<script>
import MyCourses from './Pages/MyCourses'
import MyCoCourses from './Pages/MyCoCourses'
import Cupons from './Pages/Cupons'
import Doubt from './Pages/Doubt'
import Reports from './Pages/Reports'
import Sells from './Pages/Sells'
import Finance from './Pages/Finance'

export default {
  name: 'home',
  components: {
    "my-courses": MyCourses,
    "my-co-courses": MyCoCourses,
    "cupons": Cupons,
    "doubts": Doubt,
    "reports": Reports,
    "sells": Sells,
    "finance": Finance
  },
  data () {
    return {
      page: "my-courses"
    }
  },
  methods: {
    showModalUser: function () {
      $("#user-data-modal").modal('show')
    },

    toggleMenu:function () {
      $("#wrapper").toggleClass("toggled");
    },

    showPage: function ( page ) {
      this.page = page
    }
  },
  mounted () {
    let hash = window.location.hash.substr(1)
    if ( hash ) this.page = hash
    else this.page = "my-courses"
  }
}
</script>
